export const zenithProductsData = [
  {
    "id": 513,
    "images": [],
    "tags": [
      "1"
    ],
    "name": "HAT0144",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 513,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 512,
    "images": [],
    "tags": [
      "1"
    ],
    "name": "HAT0128",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 512,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 511,
    "images": null,
    "tags": [
      "10"
    ],
    "name": "E_SWT_5XL",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 511,
    "base_cost": 1,
    "shipping_fee": 1,
    "packing_fee": 1,
    "handing_fee": 1,
    "label_fee": 0,
    "sellerIds": [],
    "listTags": [
      {
        "id": 10,
        "name": "Ship từ Việt Nam",
        "nameSearch": "ship tu viet nam",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-11-27T03:09:34.097Z",
        "updatedAt": "2024-11-27T03:09:34.097Z"
      }
    ]
  },
  {
    "id": 507,
    "images": null,
    "tags": [
      "10"
    ],
    "name": "E_SWT_XL",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 507,
    "base_cost": 1,
    "shipping_fee": 1,
    "packing_fee": 1,
    "handing_fee": 1,
    "label_fee": 0,
    "sellerIds": [],
    "listTags": [
      {
        "id": 10,
        "name": "Ship từ Việt Nam",
        "nameSearch": "ship tu viet nam",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-11-27T03:09:34.097Z",
        "updatedAt": "2024-11-27T03:09:34.097Z"
      }
    ]
  },
  {
    "id": 505,
    "images": null,
    "tags": [
      "10"
    ],
    "name": "E_SWT_M",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 505,
    "base_cost": 1,
    "shipping_fee": 1,
    "packing_fee": 1,
    "handing_fee": 1,
    "label_fee": 0,
    "sellerIds": [],
    "listTags": [
      {
        "id": 10,
        "name": "Ship từ Việt Nam",
        "nameSearch": "ship tu viet nam",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-11-27T03:09:34.097Z",
        "updatedAt": "2024-11-27T03:09:34.097Z"
      }
    ]
  },
  {
    "id": 491,
    "images": [
      "static/20250904/2025090419556530.png"
    ],
    "tags": [
      "11",
      "10"
    ],
    "name": "VN_M",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 491,
    "base_cost": 6.5,
    "shipping_fee": 6.5,
    "packing_fee": 0,
    "handing_fee": 0,
    "label_fee": 4,
    "sellerIds": [
      "9",
      "11",
      "23",
      "41",
      "42",
      "46",
      "50",
      "52",
      "53",
      "54",
      "62",
      "73",
      "51",
      "65",
      "74",
      "76",
      "55",
      "80",
      "29",
      "83",
      "87",
      "72",
      "90",
      "91",
      "15",
      "92",
      "93",
      "88",
      "94",
      "95",
      "21",
      "97",
      "17"
    ],
    "listTags": [
      {
        "id": 10,
        "name": "Ship từ Việt Nam",
        "nameSearch": "ship tu viet nam",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-11-27T03:09:34.097Z",
        "updatedAt": "2024-11-27T03:09:34.097Z"
      },
      {
        "id": 11,
        "name": "PHÔI",
        "nameSearch": "phoi",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-12-31T08:53:07.637Z",
        "updatedAt": "2024-12-31T08:53:07.637Z"
      }
    ]
  },
  {
    "id": 456,
    "images": [
      "static/20250904/2025090419526870.png"
    ],
    "tags": [
      "1",
      "10"
    ],
    "name": "VN_HAT",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 456,
    "base_cost": 6.5,
    "shipping_fee": 6.5,
    "packing_fee": 0,
    "handing_fee": 0,
    "label_fee": 4,
    "sellerIds": [
      "55",
      "51",
      "62",
      "66",
      "69",
      "71",
      "9",
      "11",
      "23",
      "42",
      "46",
      "53",
      "65",
      "74",
      "76",
      "80",
      "41",
      "83",
      "87",
      "72",
      "90",
      "54",
      "91",
      "15",
      "92",
      "93",
      "29",
      "94",
      "95",
      "73",
      "89",
      "21",
      "97",
      "17"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      },
      {
        "id": 10,
        "name": "Ship từ Việt Nam",
        "nameSearch": "ship tu viet nam",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-11-27T03:09:34.097Z",
        "updatedAt": "2024-11-27T03:09:34.097Z"
      }
    ]
  },
  {
    "id": 445,
    "images": [
      "static/20250610/2025061014228360.jpeg"
    ],
    "tags": [
      "10"
    ],
    "name": "Vanity Plate",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 445,
    "base_cost": 4,
    "shipping_fee": 7,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 3,
    "sellerIds": [
      "11",
      "10",
      "46",
      "42",
      "54",
      "55",
      "56",
      "58",
      "59",
      "51",
      "60",
      "62",
      "66",
      "68",
      "69",
      "29",
      "75",
      "77",
      "80",
      "72",
      "71",
      "83",
      "90",
      "15",
      "91",
      "92",
      "93",
      "94",
      "95",
      "21",
      "97",
      "23",
      "98"
    ],
    "listTags": [
      {
        "id": 10,
        "name": "Ship từ Việt Nam",
        "nameSearch": "ship tu viet nam",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-11-27T03:09:34.097Z",
        "updatedAt": "2024-11-27T03:09:34.097Z"
      }
    ]
  },
  {
    "id": 444,
    "images": [
      "static/20251027/2025102709067030.jpeg"
    ],
    "tags": [
      "10"
    ],
    "name": "Metal License Plate Frame",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 444,
    "base_cost": 5,
    "shipping_fee": 7,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 3,
    "sellerIds": [
      "11",
      "10",
      "46",
      "42",
      "54",
      "55",
      "56",
      "58",
      "59",
      "51",
      "60",
      "62",
      "66",
      "68",
      "69",
      "29",
      "75",
      "77",
      "80",
      "72",
      "71",
      "83",
      "90",
      "15",
      "91",
      "92",
      "93",
      "94",
      "95",
      "21",
      "97",
      "23",
      "98"
    ],
    "listTags": [
      {
        "id": 10,
        "name": "Ship từ Việt Nam",
        "nameSearch": "ship tu viet nam",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-11-27T03:09:34.097Z",
        "updatedAt": "2024-11-27T03:09:34.097Z"
      }
    ]
  },
  {
    "id": 329,
    "images": [
      "static/20250326/2025032607403240.jpeg"
    ],
    "tags": [
      "10",
      "1"
    ],
    "name": "VN_HAT0118",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 329,
    "base_cost": 6,
    "shipping_fee": 7,
    "packing_fee": 0,
    "handing_fee": 0,
    "label_fee": 5,
    "sellerIds": [
      "23",
      "24",
      "11",
      "40",
      "35",
      "10",
      "41"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      },
      {
        "id": 10,
        "name": "Ship từ Việt Nam",
        "nameSearch": "ship tu viet nam",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-11-27T03:09:34.097Z",
        "updatedAt": "2024-11-27T03:09:34.097Z"
      }
    ]
  },
  {
    "id": 328,
    "images": [
      "static/20250215/2025021513436830.jpeg"
    ],
    "tags": [
      "10",
      "1"
    ],
    "name": "VN_HAT0117",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 328,
    "base_cost": 6,
    "shipping_fee": 7,
    "packing_fee": 0,
    "handing_fee": 0,
    "label_fee": 5,
    "sellerIds": [
      "24",
      "23",
      "11",
      "40",
      "10",
      "35"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      },
      {
        "id": 10,
        "name": "Ship từ Việt Nam",
        "nameSearch": "ship tu viet nam",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-11-27T03:09:34.097Z",
        "updatedAt": "2024-11-27T03:09:34.097Z"
      }
    ]
  },
  {
    "id": 327,
    "images": [
      "static/20250215/2025021513429600.jpeg"
    ],
    "tags": [
      "10",
      "1"
    ],
    "name": "VN_HAT0116",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 327,
    "base_cost": 6,
    "shipping_fee": 7,
    "packing_fee": 0,
    "handing_fee": 0,
    "label_fee": 5,
    "sellerIds": [
      "23",
      "24",
      "11",
      "40"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      },
      {
        "id": 10,
        "name": "Ship từ Việt Nam",
        "nameSearch": "ship tu viet nam",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-11-27T03:09:34.097Z",
        "updatedAt": "2024-11-27T03:09:34.097Z"
      }
    ]
  },
  {
    "id": 324,
    "images": [
      "static/20250124/2025012408364480.jpeg",
      "static/20250221/2025022111122360.jpeg",
      "static/20250221/2025022111126330.jpeg",
      "static/20250221/2025022111122520.jpeg",
      "static/20250221/2025022111125630.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0115",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 324,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "29",
      "27",
      "26",
      "24",
      "23",
      "18",
      "17",
      "16",
      "15",
      "14",
      "13",
      "12",
      "10",
      "9",
      "35",
      "36",
      "40",
      "45",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 323,
    "images": [
      "static/20250124/2025012408360280.jpeg",
      "static/20250221/2025022111117230.jpeg",
      "static/20250221/2025022111112120.jpeg",
      "static/20250221/2025022111119050.jpeg",
      "static/20250221/2025022111114730.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0114",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 323,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "29",
      "27",
      "26",
      "24",
      "23",
      "18",
      "17",
      "16",
      "15",
      "14",
      "13",
      "12",
      "10",
      "9",
      "36",
      "40",
      "45",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 322,
    "images": [
      "static/20250124/2025012408360020.jpeg",
      "static/20250221/2025022111088620.jpeg",
      "static/20250221/2025022111087600.jpeg",
      "static/20250221/2025022111089410.jpeg",
      "static/20250221/2025022111088120.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0113",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 322,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "29",
      "27",
      "26",
      "24",
      "23",
      "18",
      "17",
      "16",
      "15",
      "14",
      "13",
      "12",
      "10",
      "9",
      "36",
      "40",
      "45",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 319,
    "images": [
      "static/20250122/2025012211106810.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0110",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 319,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "23",
      "24",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 318,
    "images": [
      "static/20250122/2025012211090640.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0099",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 318,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "23",
      "24",
      "9",
      "36",
      "40",
      "41",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 317,
    "images": [
      "static/20250122/2025012211288910.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0098",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 317,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "10",
      "35",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 316,
    "images": [
      "static/20250122/2025012211086440.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0078",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 316,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 313,
    "images": [
      "static/20250122/2025012211073800.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0105",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 313,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 312,
    "images": [
      "static/20250122/2025012211079290.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0091",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 312,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 311,
    "images": [
      "static/20250122/2025012211066110.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0093",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 311,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55",
      "17"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 310,
    "images": [
      "static/20250122/2025012211062670.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0068",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 310,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "23",
      "24",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 309,
    "images": [
      "static/20250122/2025012211053430.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0092",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 309,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 308,
    "images": [
      "static/20250122/2025012211052830.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0100",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 308,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 307,
    "images": [
      "static/20250122/2025012211045010.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0101",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 307,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 305,
    "images": [
      "static/20250122/2025012211034740.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0109",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 305,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 304,
    "images": [
      "static/20250122/2025012211023630.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0051",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 304,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "48",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 303,
    "images": [
      "static/20250122/2025012211022020.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0050",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 303,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "9",
      "23",
      "24",
      "29",
      "27",
      "36",
      "40",
      "41",
      "48",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 301,
    "images": [
      "static/20250122/2025012211018930.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0095",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 301,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 300,
    "images": [
      "static/20250122/2025012210598590.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0096",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 300,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 299,
    "images": [
      "static/20250122/2025012210594840.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0094",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 299,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 298,
    "images": [
      "static/20250122/2025012210580240.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0097",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 298,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 297,
    "images": [
      "static/20250122/2025012210587350.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0108",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 297,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 294,
    "images": [
      "static/20250122/2025012210577290.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0057",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 294,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "48",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 293,
    "images": [
      "static/20250122/2025012210567710.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0104",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 293,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "77",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 292,
    "images": [
      "static/20250122/2025012210557310.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0047",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 292,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "9",
      "24",
      "23",
      "36",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 291,
    "images": [
      "static/20250122/2025012209584580.jpeg",
      "static/20250122/2025012209597310.jpeg",
      "static/20250122/2025012209596130.jpeg",
      "static/20250122/2025012209596110.jpeg",
      "static/20250122/2025012209594860.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0059",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 291,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "48",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 290,
    "images": [
      "static/20250122/2025012209574420.jpeg",
      "static/20250122/2025012209570460.jpeg",
      "static/20250122/2025012209573890.jpeg",
      "static/20250122/2025012209573500.jpeg",
      "static/20250122/2025012209574010.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0077",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 290,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 289,
    "images": [
      "static/20250122/2025012209553150.jpeg",
      "static/20250122/2025012209568660.jpeg",
      "static/20250122/2025012209568210.jpeg",
      "static/20250122/2025012209565530.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0081",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 289,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "23",
      "24",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 288,
    "images": [
      "static/20250122/2025012209557580.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0106",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 288,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 287,
    "images": [
      "static/20250122/2025012209518950.jpeg",
      "static/20250122/2025012209516260.jpeg",
      "static/20250122/2025012209517650.jpeg",
      "static/20250122/2025012209517640.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0071",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 287,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "10",
      "35",
      "29",
      "27",
      "23",
      "24",
      "9",
      "36",
      "41",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 286,
    "images": [
      "static/20250122/2025012209505010.jpeg",
      "static/20250122/2025012209501340.jpeg",
      "static/20250122/2025012209509820.jpeg",
      "static/20250122/2025012209509790.jpeg",
      "static/20250122/2025012209502200.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0048",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 286,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "27",
      "29",
      "24",
      "23",
      "9",
      "36",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 285,
    "images": [
      "static/20250122/2025012209485550.jpeg",
      "static/20250122/2025012209480300.jpeg",
      "static/20250122/2025012209482120.jpeg",
      "static/20250122/2025012209484950.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0074",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 285,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 284,
    "images": [
      "static/20250122/2025012209444120.jpeg",
      "static/20250122/2025012209456790.jpeg",
      "static/20250122/2025012209459410.jpeg",
      "static/20250122/2025012209474320.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0066",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 284,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 283,
    "images": [
      "static/20250122/2025012209422920.jpeg",
      "static/20250122/2025012209427100.jpeg",
      "static/20250122/2025012209427080.jpeg",
      "static/20250122/2025012209436300.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0079",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 283,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 282,
    "images": [
      "static/20250122/2025012209401720.jpeg",
      "static/20250122/2025012209410030.jpeg",
      "static/20250122/2025012209414580.jpeg",
      "static/20250122/2025012209418080.jpeg",
      "static/20250122/2025012209417820.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0076",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 282,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "23",
      "24",
      "9",
      "36",
      "41",
      "40",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 281,
    "images": [
      "static/20250122/2025012209395820.jpeg",
      "static/20250122/2025012209394360.jpeg",
      "static/20250122/2025012209397810.jpeg",
      "static/20250122/2025012209391520.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0075",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 281,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 280,
    "images": [
      "static/20250122/2025012209342420.jpeg",
      "static/20250122/2025012209346900.jpeg",
      "static/20250122/2025012209350650.jpeg",
      "static/20250122/2025012209351150.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0061",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 280,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 278,
    "images": [
      "static/20250122/2025012209309450.jpeg",
      "static/20250122/2025012209311870.jpeg",
      "static/20250122/2025012209319070.jpeg",
      "static/20250122/2025012209315330.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0067",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 278,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "9",
      "24",
      "23",
      "36",
      "41",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 277,
    "images": [
      "static/20250122/2025012209241510.jpeg",
      "static/20250122/2025012209242460.jpeg",
      "static/20250122/2025012209240500.jpeg",
      "static/20250122/2025012209241040.jpeg",
      "static/20250122/2025012209242450.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0064",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 277,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 275,
    "images": [
      "static/20250122/2025012209212070.jpeg",
      "static/20250122/2025012209210760.jpeg",
      "static/20250122/2025012209219440.jpeg",
      "static/20250122/2025012209215870.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0069",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 275,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 274,
    "images": [
      "static/20250122/2025012209141830.jpeg",
      "static/20250122/2025012209150550.jpeg",
      "static/20250122/2025012209154700.jpeg",
      "static/20250122/2025012209157980.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0070",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 274,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 273,
    "images": [
      "static/20250122/2025012209063220.jpeg",
      "static/20250122/2025012209068210.jpeg",
      "static/20250122/2025012209064520.jpeg",
      "static/20250122/2025012209069620.jpeg",
      "static/20250122/2025012209063920.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0062",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 273,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 272,
    "images": [
      "static/20250117/2025011723454350.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0056",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 272,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "10",
      "35",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "48",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 270,
    "images": [
      "static/20250116/2025011614118740.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0088",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 270,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "29",
      "27",
      "24",
      "23",
      "9",
      "10",
      "36",
      "41",
      "40",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 269,
    "images": [
      "static/20250116/2025011614108600.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0058",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 269,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "48",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 268,
    "images": [
      "static/20250116/2025011614107980.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0090",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 268,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "35",
      "11",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "40",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 267,
    "images": [
      "static/20250116/2025011614091420.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0052",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 267,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "48",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 266,
    "images": [
      "static/20250116/2025011614096990.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0053",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 266,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "35",
      "10",
      "11",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "48",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 265,
    "images": [
      "static/20250116/2025011614084350.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0055",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 265,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "48",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 264,
    "images": [
      "static/20250116/2025011614070640.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0046",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 264,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "23",
      "24",
      "9",
      "36",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 263,
    "images": [
      "static/20250114/2025011408160590.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0054",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 263,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "48",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 259,
    "images": [
      "static/20250103/2025010310099280.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0107",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 259,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 258,
    "images": [
      "static/20250103/2025010318157640.jpeg",
      "static/20250103/2025010318169470.jpeg",
      "static/20250103/2025010318169550.jpeg",
      "static/20250103/2025010318169440.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0072",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 258,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 257,
    "images": [
      "static/20250103/2025010309570180.png",
      "static/20250103/2025010318181050.jpeg",
      "static/20250103/2025010318181570.jpeg",
      "static/20250103/2025010318181620.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0045",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 257,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "9",
      "10",
      "12",
      "13",
      "14",
      "15",
      "16",
      "18",
      "17",
      "23",
      "24",
      "27",
      "29",
      "36",
      "40",
      "42",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 253,
    "images": [
      "static/20250103/2025010309413400.jpeg",
      "static/20250103/2025010309426720.jpeg",
      "static/20250103/2025010309426210.jpeg",
      "static/20250103/2025010309424830.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0087",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 253,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "9",
      "36",
      "41",
      "40",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 195,
    "images": [
      "static/20241230/2024123011291050.jpeg",
      "static/20241230/2024123011305680.jpeg",
      "static/20241230/2024123011305660.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0073",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 195,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "29",
      "27",
      "24",
      "23",
      "18",
      "17",
      "16",
      "15",
      "14",
      "13",
      "12",
      "9",
      "36",
      "41",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 191,
    "images": [
      "static/20241230/2024123011280700.jpeg",
      "static/20241230/2024123011282660.jpeg",
      "static/20241230/2024123011282640.jpeg",
      "static/20241230/2024123011282650.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0060",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 191,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "35",
      "10",
      "9",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "23",
      "24",
      "27",
      "29",
      "36",
      "41",
      "48",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 97,
    "images": [
      "static/20241106/2024110610357990.png",
      "static/20241106/2024110610352980.png",
      "static/20241106/2024110610353270.png"
    ],
    "tags": [
      "6",
      "10"
    ],
    "name": "Tough Phone Cases",
    "description": "- Note ở phần link design: loại sản phẩm kèm 1 link drive/dropbox tổng hợp file design và hình ảnh mockup\n-Lưu ý: Design full background, vùng in quan trọng nên để cách mỗi viền 2cm để tránh bị in sát viền/mất chi tiết",
    "status": 1,
    "account_id": 23,
    "product_id": 97,
    "base_cost": 3,
    "shipping_fee": 5.5,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 2.5,
    "sellerIds": [
      "11",
      "10",
      "23",
      "24",
      "29",
      "9",
      "27",
      "35",
      "36",
      "38",
      "39",
      "12",
      "41",
      "42",
      "40",
      "19",
      "43",
      "45",
      "46",
      "48",
      "51",
      "52",
      "54",
      "53",
      "55",
      "56",
      "59",
      "60",
      "61",
      "62",
      "64",
      "65",
      "66",
      "70",
      "72",
      "73",
      "77",
      "78",
      "79",
      "80",
      "83",
      "84",
      "86",
      "90",
      "91",
      "92",
      "93",
      "94",
      "95",
      "21",
      "97"
    ],
    "listTags": [
      {
        "id": 6,
        "name": "Phone cases",
        "nameSearch": "phone cases",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-11-06T03:36:38.947Z",
        "updatedAt": "2024-11-06T03:36:38.947Z"
      },
      {
        "id": 10,
        "name": "Ship từ Việt Nam",
        "nameSearch": "ship tu viet nam",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-11-27T03:09:34.097Z",
        "updatedAt": "2024-11-27T03:09:34.097Z"
      }
    ]
  },
  {
    "id": 91,
    "images": [
      "static/20241031/2024103114390200.jpeg",
      "static/20241031/2024103114390020.jpeg",
      "static/20241031/2024103114399950.jpeg",
      "static/20241031/2024103114399970.jpeg",
      "static/20241031/2024103114390350.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0044",
    "description": "IMAGE: https://drive.google.com/drive/folders/1CRpkWfY_n9ZpJnf0ZiTBhLQ-GqmJUiEC?usp=drive_link",
    "status": 1,
    "account_id": 23,
    "product_id": 91,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "9",
      "10",
      "27",
      "35",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "23",
      "24",
      "29",
      "36",
      "41",
      "42",
      "45",
      "48",
      "69",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 90,
    "images": [
      "static/20241031/2024103114397680.jpeg",
      "static/20241031/2024103114395800.jpeg",
      "static/20241031/2024103114395450.jpeg",
      "static/20241031/2024103114395760.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0043",
    "description": "IMAGE: https://drive.google.com/drive/folders/1leypZp9eTjfAcRHtc5hfbGfJLPjkcRFj?usp=drive_link",
    "status": 1,
    "account_id": 23,
    "product_id": 90,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "9",
      "10",
      "35",
      "12",
      "13",
      "14",
      "15",
      "16",
      "18",
      "17",
      "23",
      "24",
      "27",
      "29",
      "36",
      "41",
      "42",
      "45",
      "48",
      "55",
      "69",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 89,
    "images": [
      "static/20241031/2024103114366320.jpeg",
      "static/20241031/2024103114360710.jpeg",
      "static/20241031/2024103114360740.jpeg",
      "static/20241031/2024103114360800.jpeg",
      "static/20241031/2024103114360980.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0042",
    "description": "IMAGE: https://drive.google.com/drive/folders/1DjP3zbm4TlPWlRZP8IdXNp19KoVY4u2N?usp=drive_link",
    "status": 1,
    "account_id": 23,
    "product_id": 89,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "10",
      "9",
      "27",
      "35",
      "29",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "23",
      "24",
      "36",
      "41",
      "42",
      "45",
      "48",
      "69",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 88,
    "images": [
      "static/20240920/2024092002335970.jpeg",
      "static/20240920/2024092002339950.jpeg",
      "static/20240920/2024092002331000.jpeg",
      "static/20240920/2024092002340650.jpeg",
      "static/20240920/2024092002344360.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "L0005",
    "description": "Kích thước design: 400x400px",
    "status": 1,
    "account_id": 23,
    "product_id": 88,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 87,
    "images": [
      "static/20240920/2024092002333080.jpeg",
      "static/20240920/2024092002337290.jpeg",
      "static/20240920/2024092002337980.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "L0004",
    "description": "Kích thước design: 400x400px",
    "status": 1,
    "account_id": 23,
    "product_id": 87,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 86,
    "images": [
      "static/20240920/2024092002324980.jpeg",
      "static/20240920/2024092002323690.jpeg",
      "static/20240920/2024092002322740.jpeg",
      "static/20240920/2024092002328300.jpeg",
      "static/20240920/2024092002327510.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "L0003",
    "description": "Kích thước design: 400x400px",
    "status": 1,
    "account_id": 23,
    "product_id": 86,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 85,
    "images": [
      "static/20240920/2024092002313960.jpeg",
      "static/20240920/2024092002315520.jpeg",
      "static/20240920/2024092002312670.jpeg",
      "static/20240920/2024092002318620.jpeg",
      "static/20240920/2024092002312190.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "L0002",
    "description": "Kích thước design: 400x400px",
    "status": 1,
    "account_id": 23,
    "product_id": 85,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 84,
    "images": [
      "static/20240920/2024092002301050.jpeg",
      "static/20240920/2024092002303680.jpeg",
      "static/20240920/2024092002300050.jpeg",
      "static/20240920/2024092002308860.jpeg",
      "static/20240920/2024092002306610.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "L0001",
    "description": "Kích thước design: 400x400px",
    "status": 1,
    "account_id": 23,
    "product_id": 84,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 62,
    "images": [
      "static/20240912/2024091202112020.jpeg",
      "static/20240920/2024092002255570.jpeg",
      "static/20240920/2024092002256310.jpeg",
      "static/20240920/2024092002256350.jpeg",
      "static/20240920/2024092002255110.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0020",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 62,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "24",
      "26",
      "23",
      "21",
      "18",
      "17",
      "16",
      "15",
      "14",
      "13",
      "12",
      "11",
      "10",
      "9",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 40,
    "images": [
      "static/20240912/2024091201036020.jpeg",
      "static/20240912/2024091201036630.jpeg",
      "static/20240912/2024091201036660.jpeg",
      "static/20240912/2024091201036680.jpeg",
      "static/20240912/2024091201036770.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0041",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 40,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "58",
      "69",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 39,
    "images": [
      "static/20240912/2024091201021290.jpeg",
      "static/20240912/2024091201031940.jpeg",
      "static/20240912/2024091201031380.jpeg",
      "static/20240912/2024091201031370.jpeg",
      "static/20240912/2024091201031620.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0040",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 39,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "36",
      "35",
      "41",
      "42",
      "45",
      "48",
      "69",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 38,
    "images": [
      "static/20240912/2024091201021190.jpeg",
      "static/20240912/2024091201022060.jpeg",
      "static/20240912/2024091201022190.jpeg",
      "static/20240912/2024091201022230.jpeg",
      "static/20240912/2024091201022220.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0039",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 38,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "13",
      "12",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "48",
      "45",
      "42",
      "69",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 37,
    "images": [
      "static/20240912/2024091201023830.jpeg",
      "static/20240912/2024091201025410.jpeg",
      "static/20240912/2024091201025400.jpeg",
      "static/20240912/2024091201025360.jpeg",
      "static/20240912/2024091201025320.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0038",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 37,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "10",
      "9",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "69",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 36,
    "images": [
      "static/20240912/2024091201015450.jpeg",
      "static/20240912/2024091201014110.jpeg",
      "static/20240912/2024091201014220.jpeg",
      "static/20240912/2024091201014210.jpeg",
      "static/20240912/2024091201014190.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0037",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 36,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "69",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 35,
    "images": [
      "static/20240912/2024091201018490.jpeg",
      "static/20240912/2024091201018660.jpeg",
      "static/20240912/2024091201018640.jpeg",
      "static/20240912/2024091201018650.jpeg",
      "static/20240912/2024091201018620.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0036",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 35,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "69",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 34,
    "images": [
      "static/20240912/2024091201018330.jpeg",
      "static/20240912/2024091201015960.jpeg",
      "static/20240912/2024091201015970.jpeg",
      "static/20240912/2024091201015850.jpeg",
      "static/20240912/2024091201016010.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0035",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 34,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "18",
      "17",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "69",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 33,
    "images": [
      "static/20240912/2024091201007920.jpeg",
      "static/20240912/2024091201009030.jpeg",
      "static/20240912/2024091201009060.jpeg",
      "static/20240912/2024091201009110.jpeg",
      "static/20240912/2024091201009110.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0034",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 33,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "26",
      "24",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "69",
      "55",
      "51"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 32,
    "images": [
      "static/20240912/2024091201000250.jpeg",
      "static/20240912/2024091201008200.jpeg",
      "static/20240912/2024091201008240.jpeg",
      "static/20240912/2024091201008180.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0033",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 32,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "21",
      "18",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "69",
      "51",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 31,
    "images": [
      "static/20240912/2024091201006770.jpeg",
      "static/20240912/2024091201004060.jpeg",
      "static/20240912/2024091201004020.jpeg",
      "static/20240912/2024091201004100.jpeg",
      "static/20240912/2024091201004190.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0032",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 31,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "51",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 30,
    "images": [
      "static/20240912/2024091201009370.jpeg",
      "static/20240912/2024091208394170.jpeg",
      "static/20240912/2024091208394530.jpeg",
      "static/20240912/2024091208394550.jpeg",
      "static/20240912/2024091208394890.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0031",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 30,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "51",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 29,
    "images": [
      "static/20240912/2024091201007350.jpeg",
      "static/20240912/2024091208386840.jpeg",
      "static/20240912/2024091208386970.jpeg",
      "static/20240912/2024091208387250.jpeg",
      "static/20240912/2024091208387310.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0030",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 29,
    "base_cost": 8,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "51",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 28,
    "images": [
      "static/20240912/2024091200596700.jpeg",
      "static/20240912/2024091200594740.jpeg",
      "static/20240912/2024091200594800.jpeg",
      "static/20240912/2024091200594760.jpeg",
      "static/20240912/2024091200594810.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0029",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 28,
    "base_cost": 8,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "51",
      "69",
      "55",
      "82"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 27,
    "images": [
      "static/20240912/2024091200595820.jpeg",
      "static/20240912/2024091208379630.jpeg",
      "static/20240912/2024091208379640.jpeg",
      "static/20240912/2024091208385200.jpeg",
      "static/20240912/2024091208385320.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0028",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 27,
    "base_cost": 8,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "11",
      "9",
      "10",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "51",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 26,
    "images": [
      "static/20240912/2024091200591430.jpeg",
      "static/20240912/2024091208363550.jpeg",
      "static/20240912/2024091208363540.jpeg",
      "static/20240912/2024091208369790.jpeg",
      "static/20240912/2024091208364260.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0027",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 26,
    "base_cost": 8,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "26",
      "24",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "51",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 25,
    "images": [
      "static/20240912/2024091200594290.jpeg",
      "static/20240912/2024091208358510.jpeg",
      "static/20240912/2024091208351700.jpeg",
      "static/20240912/2024091208352960.jpeg",
      "static/20240912/2024091208355550.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0026",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 25,
    "base_cost": 8,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "51",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 24,
    "images": [
      "static/20240912/2024091200595700.jpeg",
      "static/20240912/2024091208343490.jpeg",
      "static/20240912/2024091208343400.jpeg",
      "static/20240912/2024091208345270.jpeg",
      "static/20240912/2024091208347090.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0025",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 24,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "24",
      "26",
      "29",
      "27",
      "35",
      "41",
      "42",
      "45",
      "48",
      "51",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 23,
    "images": [
      "static/20240912/2024091200588030.jpeg",
      "static/20240912/2024091208331420.jpeg",
      "static/20240912/2024091208333070.jpeg",
      "static/20240912/2024091208333220.jpeg",
      "static/20240912/2024091208333260.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0024",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 23,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "23",
      "26",
      "24",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "48",
      "45",
      "51",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 22,
    "images": [
      "static/20240912/2024091200588840.jpeg",
      "static/20240920/2024092002228330.jpeg",
      "static/20240920/2024092002224550.jpeg",
      "static/20240920/2024092002224050.jpeg",
      "static/20240920/2024092002225180.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0023",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 22,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "24",
      "23",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "51",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 21,
    "images": [
      "static/20240912/2024091200582740.jpeg",
      "static/20240912/2024091208329820.jpeg",
      "static/20240912/2024091208329890.jpeg",
      "static/20240912/2024091208329840.jpeg",
      "static/20240912/2024091208320580.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0022",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 21,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "18",
      "17",
      "21",
      "24",
      "23",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "51",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 20,
    "images": [
      "static/20240912/2024091200585520.jpeg",
      "static/20240912/2024091208312400.jpeg",
      "static/20240912/2024091208312660.jpeg",
      "static/20240912/2024091208312720.jpeg",
      "static/20240912/2024091208312930.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0021",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 20,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "24",
      "23",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "51",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 19,
    "images": [
      "static/20240912/2024091200540640.jpeg",
      "static/20240912/2024091208306030.jpeg",
      "static/20240912/2024091208306050.jpeg",
      "static/20240912/2024091208306090.jpeg",
      "static/20240912/2024091208306300.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0019",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 19,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "21",
      "24",
      "23",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "51",
      "69",
      "55"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  },
  {
    "id": 18,
    "images": [
      "static/20240912/2024091200547460.jpeg",
      "static/20240920/2024092002219070.jpeg",
      "static/20240920/2024092002217280.jpeg",
      "static/20240920/2024092002216560.jpeg",
      "static/20240920/2024092002217290.jpeg"
    ],
    "tags": [
      "1"
    ],
    "name": "HAT0018",
    "description": null,
    "status": 1,
    "account_id": 23,
    "product_id": 18,
    "base_cost": 8.5,
    "shipping_fee": 4.99,
    "packing_fee": 1,
    "handing_fee": 0,
    "label_fee": 0.5,
    "sellerIds": [
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "23",
      "24",
      "21",
      "26",
      "29",
      "27",
      "35",
      "36",
      "41",
      "42",
      "45",
      "48",
      "51",
      "55",
      "69"
    ],
    "listTags": [
      {
        "id": 1,
        "name": "HAT",
        "nameSearch": "hat",
        "status": 1,
        "deletedAt": null,
        "createdAt": "2024-09-12T00:51:15.695Z",
        "updatedAt": "2024-09-12T00:51:15.695Z"
      }
    ]
  }
];
